import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './pendenciaTipoForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import { sortData } from '../common/table/sortHelper';

import { 
	setModoTela, setFiltro, initForm, salvar, excluir, getLista,
} from './pendenciaTipoActions';
import { 
	getLista as getListaSetor
} from '../setor/setorActions';

const columns = [{
    field: 'nome',
    type: 'text'
}, {
    field: 'nome_setor',
    type: 'text'
}, {
	field: 'obrigatoria',
    type: 'boolean'
}];

class PendenciaTipo extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'nome',
			direction: 'asc'
		}
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista();
		this.props.getListaSetor();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={(registro) => this.props.salvar(registro)} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={(registro) => this.props.excluir(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
		)
	}

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.props.filtro.pesquisar || '').trim()
				|| (this.props.filtro.pesquisar.toUpperCase() || '')
					.split('+')
					.filter(p => p.trim())
					.some(pesquisar => `
						${item.nome}
						${item.nome_setor}
						${item.obrigatoria ? 'Sim' : 'Não'}
					`.toUpperCase().includes(pesquisar.trim())
					);
		});

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}

	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.filtrar();

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.props.filtro.pesquisar}
							onChange={value => this.props.setFiltro({ ...this.props.filtro, pesquisar: value })} />
							
						<Select
							options={this.props.listaSetor}
							label='Setor'
							cols='12 1 1 1'
							minWidth={300}
							placeholder='Selecione'
							value={this.props.filtro.id_setor}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									id_setor: value
								});
							}} />

						<div style={{ width: 310, marginTop: 8, marginLeft: 8 }}>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>

							<ExcelFile
								filename={'Tipos de Pendência'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									obrigatoria: item.obrigatoria ? 'Sim' : 'Não'
								}))} name='Tipos de Pendência'>
									<ExcelColumn label='Nome' value='nome' />
									<ExcelColumn label='Setor' value='nome_setor' />
									<ExcelColumn label='Obrigatória' value='obrigatoria' />
								</ExcelSheet>
							</ExcelFile>

						</div>
					</Row>

					<Table responsive border striped alturaFixa
						maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
							window.innerWidth < 1093 ? `${window.innerHeight - 300}px`
								: (
									window.innerWidth < 1799
										? `${window.innerHeight - 180}px`
										: (
											window.innerWidth < 4000
												? `${window.innerHeight - 180}px`
												: `${window.innerHeight - 110}px`
										)
								)
						)}>
						<THead>
							<Tr backgroundColor={'#1F3066'}
								color={'#ffffff'}
								height={47}>
								
								<ThSort
									field='nome'
									label='Nome'
									width={300}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='nome_setor'
									label='Setor'
									width={300}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='obrigatoria'
									label='Obrigatória'
									width={100}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<Th paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} width={50} alignCenter></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map((item, i) => (
								<Tr key={item.id}
									backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td color={'#000'} alignCenter small>{item.nome}</Td>
									<Td color={'#000'} alignCenter small>{item.nome_setor}</Td>
									<Td color={'#000'} alignCenter small>{item.obrigatoria ? 'Sim' : 'Não'}</Td>
									<Td minWidth={50} width={50} alignCenter>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={true}
											small
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={true}
												small
												event={() => {
													this.props.setModoTela('exclusao', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.pendenciaTipo.aguardando,
	modoTela: state.pendenciaTipo.modoTela,
	lista: state.pendenciaTipo.lista.filter(item => {
		const setor = state.setor.listaSelect.filter(setor => setor.id == item.id_setor)[0];

		return setor && (
			(setor.ids_usuarios || []).includes(state.auth.usuario.id)
			|| (setor.ids_usuarios_supervisores || []).includes(state.auth.usuario.id)
			|| (setor.ids_usuarios_gestores || []).includes(state.auth.usuario.id)
		);
	}),
	filtro: state.pendenciaTipo.filtro,
	listaSetor: state.setor.listaSelect.filter(item => {
		return (item.ids_usuarios_completo || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_supervisores_completo || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_gestores_completo || []).includes(state.auth.usuario.id);
	}).map(item => ({
		...item,
		permissao: (item.ids_usuarios_gestores_completo || []).includes(state.auth.usuario.id) ? 'GESTOR' : (
			(item.ids_usuarios_supervisores_completo || []).includes(state.auth.usuario.id) ? 'SUPERVISOR' : (
				(item.ids_usuarios_completo || []).includes(state.auth.usuario.id) ? 'USUARIO' 
				: 'SEM PERMISSAO'
			)
		)
	}))
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvar, excluir, getLista,
	getListaSetor
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PendenciaTipo);
